/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('checking');
const CHECK_LIST = "CHECK_LIST";
const CHECK_ADD = "CHECK_ADD";
const CHECK_DELETE = "CHECK_DELETE";
const CHECK_EXPORT = "CHECK_EXPORT";
const CHECK_DETAIL = "CHECK_DETAIL";
const CHECK_FINANCE_SUM_LIST = "CHECK_FINANCE_SUM_LIST";
const CHECK_USER_TOTAL = "CHECK_USER_TOTAL";
const CHECK_USER_EXPAND = "CHECK_USER_EXPAND";
const CHECK_USER_REMIT = "CHECK_USER_REMIT";
const CHECK_USER_INCOME = "CHECK_USER_INCOME";
const CHECK_USER_DETAIL_EXPORT = "CHECK_USER_DETAIL_EXPORT";
const CHECK_REBUILD_BILL = "CHECK_REBUILD_BILL";
const CHECK_UPDATE_BATCH = "CHECK_UPDATE_BATCH";
const CHECK_DETAIL_EXPORT = "CHECK_DETAIL_EXPORT";
const CHECK_CURRENT_USER_CLEAR = "CHECK_CURRENT_USER_CLEAR";
const CHECK_RESET_STATUS = "CHECK_RESET_STATUS";
const CHECK_BATCH_ZERO = "CHECK_BATCH_ZERO";
const CHECK_CREATE_PRECHECK = "CHECK_CREATE_PRECHECK";

export default {
    CHECK_CREATE_PRECHECK,
    createPrecheck:(data)=>{
      return ajaxCommon({
        data,
        api:TheApi('post')('precheck'),
        success:(res)=>({
          type:CHECK_CREATE_PRECHECK,
          data:res
        })
      })
    },
    CHECK_LIST,
    checkList : (search)=>{
        if(search && typeof search.current != 'undefined'){
            search.page = search.current || 1;//保持antd的风格
            delete search.current;
        }
        return ajaxCommon({
            data:search,
            api:API('checkingdetail')('get')(),
            success: (data)=>({
                type:CHECK_LIST,
                data
            })
        })
    },
    CHECK_FINANCE_SUM_LIST,
    checkFinanceSumList : (search)=>{
        if(search){
            search.page = search.current || 1;
            delete search.current;
        }
        search.pagesize = 13;

        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:CHECK_FINANCE_SUM_LIST,
                data
            })
        })
    },
    CHECK_ADD,
    checkAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:CHECK_ADD,
                data
            })
        })
    },
    CHECK_DELETE,
    checkDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:CHECK_DELETE,
                data,
            })
        })
    },
    CHECK_DETAIL,
    checkDetail:()=>{
        // 注意，这个接口需要保留，但是什么事情都不做, 否则因为通用性的东西会报错
        return {
            type: CHECK_DETAIL,
            // data 务必是一个对象，否则reducer上会出错
            data: {},
        }
    },
    CHECK_USER_TOTAL,
    checkUserTotal: (adminid, month, areacode)=>
        ajaxCommon({
            api:TheApi('get')('user/total'),
            data: {adminid, month, areacode},
            success:(data)=>({
                type:CHECK_USER_TOTAL,
                data,
            }),
        }),
    CHECK_USER_EXPAND,
    checkUserExpand: (adminid, month , areacode, page=1)=>
        ajaxCommon({
            api:TheApi('get')('user/expand'),
            data: {adminid, month, areacode, page},
            success:(data)=>({
                type:CHECK_USER_EXPAND,
                data,
            }),
        }),
    CHECK_USER_REMIT,
    checkUserRemit: (adminid, month , areacode, page=1)=>
        ajaxCommon({
            api:TheApi('get')('user/remit'),
            data: {adminid, month, areacode, page},
            success:(data)=>({
                type:CHECK_USER_REMIT,
                data,
            }),
        }),
    CHECK_USER_INCOME,
    checkUserIncome: (adminid, month , areacode, oper, page=1)=>
        ajaxCommon({
            api:TheApi('get')('user/income'),
            data: {adminid, month, page,areacode, oper, pagesize:10},
            success:(data)=>({
                type:CHECK_USER_INCOME,
                data,
                oper,
            }),
        }),
    CHECK_REBUILD_BILL,
    checkRebuildBill:(areacode, month)=>
        ajaxCommon({
            api:TheApi('post')('generator'),
            data: {areacode, month},
            success:(data)=>({
                type:CHECK_REBUILD_BILL,
                data,
            })
        }),
    CHECK_BATCH_ZERO,
    checkBatchZero:(areacode, month)=>{
      return ajaxCommon({
        api:API('checkingdetail')('post')('update/zero'),
        data:{
          areacode,
          month
        },
        success:(data)=>({
          type:CHECK_BATCH_ZERO,
          data,
        })
      })
    },
    CHECK_UPDATE_BATCH,
    checkUpdateBatch:(areacode, month,data)=>
        ajaxCommon({
            api:API('checkingdetail')('post')('update/batch'),
            data: {areacode, month, data},
            success:(data)=>({
                type:CHECK_UPDATE_BATCH,
                data,
            })
        }),
    CHECK_DETAIL_EXPORT,
    checkDetailExport:(data)=>ajaxCommon({
        api:API('checkingdetail')('get')('export'),
        data:data,
        success:(data)=>({
            type:CHECK_DETAIL_EXPORT,
            data
        })
    }),
    CHECK_USER_DETAIL_EXPORT,
    checkUserDetailExport:(data)=>ajaxCommon({
        api:API('checking')('get')('user/export'),
        data:data,
        success:(data)=>({
            type:CHECK_DETAIL_EXPORT,
            data
        })
    }),
    CHECK_EXPORT,
    checkExport:(data)=>ajaxCommon({
        api:API('checking')('get')('export'),
        data:data,
        success:(data)=>({
            type:CHECK_EXPORT,
            data
        })
    }),
    CHECK_CURRENT_USER_CLEAR,
    clearCurrentCheckUser:()=>{
        return {
            type:CHECK_CURRENT_USER_CLEAR
        };
    },
    CHECK_RESET_STATUS,
    checkResetStatus:(id)=>ajaxCommon({
        api:API('checkingdetail')('post')('status/reset'),
        data:{
            id
        },
        success:(data)=>({
            type:CHECK_RESET_STATUS,
            data
        })
    })
}



// WEBPACK FOOTER //
// ./src/actions/CheckAction.js